import React, { useState } from 'react';

const encode = (data) =>
  Object.keys(data)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');

const EMPTY = { fname: '', lname: '', phone: '', email: '', eventType: '', date: '', message: '' };

export default function Callback() {
  const [form, setForm] = useState(EMPTY);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(false);

    const name = form.fname.trim();
    const phone = form.phone.trim();
    const email = form.email.trim();

    if (!name || !phone || !email) {
      alert('Please enter your name, phone number, and email address before submitting.');
      return;
    }

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'contact', ...form }),
    })
      .then(() => { setSubmitted(true); setForm(EMPTY); })
      .catch(() => setError(true));
  };

  return (
    <section id="callback" className="callback-section">
      <div className="container">
        <div className="callback-wrap">
          <div>
            <p className="section-label">Get in Touch</p>
            <h2 className="section-title">Request a <span>Quote</span></h2>
            <div className="callback-info">
              <p>
                Interested in RushPutt for your event? Fill in the form and our team will be in touch
                within 24 hours to discuss your needs and put together a tailored quote.
              </p>
            </div>
            <div className="contact-items">
              {[
                { icon: 'M6.62 10.79c1.44 2.83 3.76 5.15 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z', label: 'Phone', value: "We'll call you back within 24 hours" },
                { icon: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z', label: 'Email', value: 'seamus.ferry@rushputt.com' },
                { icon: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z', label: 'Based In', value: 'Available UK-wide for events' },
              ].map((c) => (
                <div className="contact-item" key={c.label}>
                  <div className="contact-icon">
                    <svg viewBox="0 0 24 24"><path d={c.icon} /></svg>
                  </div>
                  <div>
                    <strong>{c.label}</strong>
                    <span>{c.value}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <form
            className="callback-form"
            name="contact"
            method="POST"
            data-netlify="true"
            onSubmit={handleSubmit}
          >
            <input type="hidden" name="form-name" value="contact" />
            <div className="form-row">
              <div className="form-group">
                <label>First Name</label>
                <input name="fname" value={form.fname} onChange={handleChange} placeholder="John" required />
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input name="lname" value={form.lname} onChange={handleChange} placeholder="Smith" />
              </div>
            </div>
            <div className="form-group">
              <label>Phone Number</label>
              <input name="phone" type="tel" value={form.phone} onChange={handleChange} placeholder="+44 7700 000000" required />
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="john@company.com" required />
            </div>
            <div className="form-group">
              <label>Event Type</label>
              <select name="eventType" value={form.eventType} onChange={handleChange}>
                <option value="" disabled>Select event type...</option>
                {['Corporate Event','Birthday Party','Golf Day','Wedding / Reception','Festival / Fair','Pub / Venue Hire','Other'].map(o => <option key={o}>{o}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Event Date</label>
              <input name="date" type="date" value={form.date} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Message (optional)</label>
              <textarea name="message" value={form.message} onChange={handleChange} placeholder="Tell us a bit about your event..." />
            </div>

            {error && (
              <div className="error-msg">Something went wrong. Please email us directly at seamus.ferry@rushputt.com</div>
            )}

            {!submitted ? (
              <button type="submit" className="form-submit">Request a Quote →</button>
            ) : (
              <div className="success-msg">✓ Thanks! We'll be in touch within 24 hours.</div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
